module.exports = __webpack_public_path__ + "static/media/Amenities.5f9c841e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Amenities.jpg
// module id = 343
// module chunks = 0